import React from 'react';
import { PageHeader } from '@/components/PageHeader';
import { KpiCard } from '@/components/KpiCard';
import { Button } from '@/components/ui/button';
import { Check, CreditCard, Zap } from 'lucide-react';

const PLANS = [
  { name: 'Trial', price: '$0', period: '14 days', agents: 10, active: true, features: ['10 agents', 'Shared workers', 'Community support'] },
  { name: 'Operator', price: '$499', period: '/ month', agents: 50, features: ['50 agents', 'Dedicated Camoufox worker', 'Priority support', 'Custom proxies'] },
  { name: 'Fleet', price: 'Custom', period: '', agents: '∞', features: ['Unlimited agents', 'Kubernetes deploys', 'Compliance reports', 'Dedicated SE'] },
];

export default function Billing() {
  return (
    <div className="space-y-6" data-testid="billing-page">
      <PageHeader eyebrow="Commercial" title="Billing" description="Usage-based billing. Pay with card or crypto." />

      <div className="grid gap-4 sm:grid-cols-2 xl:grid-cols-3">
        <KpiCard label="Agent hours (month)" value="482" hint="Limit: 2,000" icon={Zap} />
        <KpiCard label="Actions executed" value="12,380" hint="Last 30 days" icon={Check} />
        <KpiCard label="Spend (month)" value="$412.30" hint="Projected $578" icon={CreditCard} />
      </div>

      <div className="grid gap-4 md:grid-cols-3">
        {PLANS.map((p) => (
          <div key={p.name} className={`rounded-lg border p-5 ${p.active ? 'border-[hsl(var(--primary))/0.5] bg-[hsl(var(--primary))/0.05]' : 'border-white/5 bg-[hsl(var(--surface-1))]'}`} data-testid={`plan-card-${p.name.toLowerCase()}`}>
            <div className="flex items-center justify-between">
              <div className="text-sm font-medium tracking-tight">{p.name}</div>
              {p.active && <span className="rounded-full border border-[hsl(var(--primary))/0.3] bg-[hsl(var(--primary))/0.15] px-2 py-0.5 text-[10px] uppercase tracking-wider text-[hsl(var(--primary))]">Current</span>}
            </div>
            <div className="mt-4 flex items-end gap-1">
              <span className="text-3xl font-semibold tabular">{p.price}</span>
              <span className="mb-1 text-xs text-[hsl(var(--text-3))]">{p.period}</span>
            </div>
            <ul className="mt-5 space-y-2 text-sm">
              {p.features.map((f) => (
                <li key={f} className="flex items-start gap-2">
                  <Check className="mt-0.5 h-4 w-4 text-[hsl(var(--primary))]" />
                  <span className="text-[hsl(var(--text-2))]">{f}</span>
                </li>
              ))}
            </ul>
            <Button className="mt-6 w-full" variant={p.active ? 'secondary' : 'default'} disabled={p.active} data-testid={`plan-select-${p.name.toLowerCase()}`}>
              {p.active ? 'Current plan' : `Upgrade to ${p.name}`}
            </Button>
          </div>
        ))}
      </div>

      <div className="rounded-lg border border-white/5 bg-[hsl(var(--surface-1))] p-5">
        <div className="text-sm font-medium">Invoices</div>
        <div className="mt-3 text-sm text-[hsl(var(--text-3))]">Connect Stripe or Cryptomus to see invoice history. Billing integration is in preview.</div>
      </div>
    </div>
  );
}
